/**
 * Draws an SVG path for a bar with rounded top corners.
 */
export function roundedTopPath(x: number, y: number, w: number, h: number, r: number): string {
  if (h <= 0) return '';
  const cr = Math.min(r, h / 2, w / 2);
  return [
    `M${x},${y + cr}`,
    `Q${x},${y} ${x + cr},${y}`,
    `L${x + w - cr},${y}`,
    `Q${x + w},${y} ${x + w},${y + cr}`,
    `L${x + w},${y + h}`,
    `L${x},${y + h}`,
    'Z',
  ].join(' ');
}
